<template>
  <div class="content-main page-complain">
    <div class="complain-hint"><span class="star-dot">*</span>请选择投诉该账号的原因</div>
    <div class="complains">
      <div class="complain flex-box" :class="{'noBorder': reason.id == 7}"
      v-for="reason in reasons"
      :key="reason.id"
      @click="handleComplain(reason.id)">
        <span>{{ reason.name }}</span><img class="right-arrow" :src="rightArrow"/>
      </div>
    </div>

  </div>
</template>

<script>
export default{
  data(){
    return {
      reasons: [
        {name: "频繁发送消息对我造成骚扰", id: 9},
        {name: "存在欺诈行为", id: 1},
        {name: "发布不实信息", id: 4},
        {name: "态度恶劣等不友善行为", id: 21},
        {name: "咨询问题长期无回复", id: 11},
        {name: "咨询问题未解决", id: 12},
        {name: "其他", id: 7}
      ],
      rightArrow: `${this.$store.state.staticUrl}/icon-right-arrow-20211216.png`
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },

    handleComplain(type){
      var searchParams = new URLSearchParams(window.location.search)
      this.$router.replace(`/complain_edit?type=${type}`)
    },
    setHtmlFontSize () {
      const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      const htmlDom = document.getElementsByTagName('html')[0]
      htmlDom.style.fontSize = htmlWidth / 10 + 'px'
    }
  },
  mounted(){
    this.setHtmlFontSize()
  }
}
</script>

<style scoped>
.content-main{
  text-align:left;
  color:#222;
  font-size:30px;
  background-color:#f4f4f4;
  min-height:100vh;
}
.complain-hint{
  /* color:#666; */
  padding-top:60px;
  padding-bottom:20px;
  text-align:left;
  font-size:24px;
  padding-left:40px;
  color:#999;
}
.complain-hint .star-dot{color:red;margin-right:10px;}
.complains{
  /* padding: 0px 40px; */
  padding-left:40px;
  padding-right:40px;
  border-top: solid 1px #e0e0e0;
  /* border-bottom: solid 1px #e0e0e0; */
  background:#fff;
}
.complain{
  border-bottom: solid 1px #e0e0e0;
  padding:30px 0px;
  justify-content:space-between;
}
.complain .right-arrow{
  height:30px;width:30px;
}
.complain.noBorder{
  border:none;
}
</style>
